import { useContext, useEffect, useRef, useState } from 'react';
import { Box, Fab, Typography } from '@mui/material';
import ButtonSizes from 'src/components/PositionButtons/PositionButtons';
import TextFieldPlayers from 'src/components/TextField/TextFieldPlayers';
import PlayersTable from 'src/components/Table/PlayersTable';
import { getPlayersRTCValues } from 'src/api/getRtcValues';
import { SidebarContext } from 'src/contexts/SidebarContext';
import Loader from 'src/components/Loader/Loader';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

function PlayersPage() {
  //Get  token from the SidebarContext
  const { token } = useContext(SidebarContext);
  // State for render data coming from the endpoint
  const [rtcValues, setRtcValues] = useState([]);
  const [error, setError] = useState('');
  // State for search text
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedPosition, setSelectedPosition] = useState(null);

  //Useref to scroll up the app if button fab is clicked
  const topRef = useRef(null);
  //This menu heigth functionality is because when scrolling up with button fab, the REDRAFT VALUES text and ButtonSizes component are covered by the dashboard header menu
  const menuHeight = 80;
  const scrollToTop = () => {
    if (topRef.current) {
      window.scrollTo({
        top: topRef.current.offsetTop - menuHeight,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const fetchRtcValueData = async () => {
      setLoading(true);
      try {
        const data = await getPlayersRTCValues(token);
        const sortedData = data.slice().sort((a, b) => {
          const algoA = parseFloat(a.rtc_value || '0') + (a.offset || 0);
          const algoB = parseFloat(b.rtc_value || '0') + (b.offset || 0);
          return algoB - algoA;
        });
        setRtcValues(sortedData);
      } catch (error) {
        console.error('Error fetching RTC values:', error);
      } finally {
        setLoading(false);
      }
    };
    if (token) {
      fetchRtcValueData();
    }
  }, [token]);

  const handlePositionSelect = (positions) => {
    setSelectedPosition(positions);
  };

  // Filter names of players in rtcValues for searchText
  const filteredRtcValues = rtcValues.filter((player) => player.name.toLowerCase().includes(searchText.toLowerCase()));

  console.log('Rtc Values', rtcValues);

  return (
    <>
      <Box ref={topRef}></Box>
      <Typography variant="h4" sx={{ fontFamily: 'sarabun', color: '#ffffff', textAlign: 'center' }}>
        REDRAFT VALUES
      </Typography>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ButtonSizes onSelectPosition={handlePositionSelect} />
          <TextFieldPlayers searchText={searchText} setSearchText={setSearchText} />
          <PlayersTable rtcValues={filteredRtcValues} setRtcValues={setRtcValues} positionFilter={selectedPosition} />
        </>
      )}
      {/* Button to go to top */}
      <Fab color="info" aria-label="scroll to top" onClick={scrollToTop} size="small" sx={{ position: 'fixed', bottom: 70, right: 16 }}>
        <ArrowUpwardIcon />
      </Fab>
    </>
  );
}

export default PlayersPage;
